import React, { useState, useEffect } from "react";
import { Box, Typography, Button, IconButton, Grid } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import AddEquipment from "./AddEquipment";
import { useUser } from "../../../../context/AuthContext";

function ViewEquipment(props) {
  const [addFacility, setAddEquipment] = useState(false);
  const { user } = useUser();

  useEffect(() => {
    console.log(props.selectedEquipment, "props");
  }, [props]);

  const Edit = () => {
    props.handleEdit();
  };

  const list = () => (
    <Box
      display="flex"
      gap={3}
      style={{
        width: "28rem",
        maxWidth: "100%",
        // width: 422,
        // maxWidth: "100%",
        height: "100vh",
        display: "flex",
        justifyContent: "space-between",
        backgroundColor: "transparent",
        overflowX: "hidden",
      }}
    >
      <AddEquipment
        addFacility={addFacility}
        setAddFacility={setAddEquipment}
        selectedEquipment={props.selectedEquipment}
        setsnackOpen={props.setsnackOpen}
        fetchFacilities={props.fetchFacilities}
      />

      <Box
        sx={{
          backgroundColor: "#fff",
          height: "3%",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton
          onClick={() => props.setViewFacility(false)}
          sx={{ color: "black" }}
        >
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{
          p: 3,
          width: "100%",
          backgroundColor: "#fff",
          height: "100%",
          overflow: "auto",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            textDecoration: "underline",
            fontWeight: "bold",
            mb: 2,
          }}
        >
          Industrial Equipment Details
        </Typography>

        {/* Displaying selected facility information */}
        <Grid container spacing={2}>
          {/* Date and Location */}
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
              Date
            </Typography>
            <p>
              {new Date(props.selectedEquipment?.createdAt).toLocaleDateString(
                "en-GB",
                {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                }
              ) ?? ""}
            </p>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
              Location
            </Typography>
            <p>{props.selectedEquipment?.location ?? ""}</p>
          </Grid>

          {/* Facility and Equipment Name */}
          {/* <Grid item xs={12} sm={6}> */}
          {/* <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: -1 }}>
              Facility
            </Typography>
            <p>{props.selectedEquipment?.facility?.facilityName ?? ""}</p> */}
          {/* </Grid> */}

          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: -1 }}>
              Industrial Process
            </Typography>
            <p>
              {props.selectedEquipment?.industrialProcess?.industryProcess ??
                ""}
            </p>
            {/* <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: -1 }}>
              Equipment Name
            </Typography>
            <p>{props.selectedEquipment?.name ?? ""}</p> */}
          </Grid>

          {/* Equipment Type and Fuel Type */}
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: -1 }}>
              Equipment Type
            </Typography>
            <p>{props.selectedEquipment?.equipmentType?.name ?? ""}</p>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: -1 }}>
              Equipment Name
            </Typography>
            <p>{props.selectedEquipment?.name ?? ""}</p>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: -1 }}>
              Fuel Type
            </Typography>
            <p>{props.selectedEquipment?.fuelType ?? ""}</p>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: -1 }}>
              No of Equipment
            </Typography>
            <p>{props.selectedEquipment?.noOfEquipment ?? ""}</p>
          </Grid>
        </Grid>

        {/* Displaying equipmentForms if they exist */}
        {props.selectedEquipment?.equipments &&
          props.selectedEquipment.equipments.length > 0 && (
            <>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: "bold", mt: 2, textDecoration: "underline" }}
              >
                Equipment Details
              </Typography>

              {props.selectedEquipment?.equipments.length > 0 &&
                props.selectedEquipment.equipments.map((form, index) => (
                  <Box
                    key={form.uniqueID}
                    sx={{
                      // p: 2,
                      // border: "1px solid #ccc",
                      // borderRadius: "8px",
                      mb: 2,
                      // backgroundColor: "#f9f9f9",
                    }}
                  >
                    <Typography
                      variant="subtitle2"
                      sx={{ fontWeight: "bold", mt: 2, mb: 2 }}
                    >
                      Equipment {index + 1}:
                    </Typography>

                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Typography variant="body2">
                          <strong>Unique ID:</strong>
                          <br />
                          {form.uniqueID}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="body2">
                          <strong>Brand:</strong> <br />
                          {form.brand}
                        </Typography>
                      </Grid>

                      <Grid item xs={6}>
                        <Typography variant="body2">
                          <strong>Model:</strong> <br />
                          {form.model}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="body2">
                          <strong>Rated Fuel Consumption:</strong> <br />
                          {form.ratedFuelConsumption}
                        </Typography>
                      </Grid>

                      <Grid item xs={12}>
                        <Typography variant="body2">
                          <strong>Unit of Fuel Consumption:</strong> <br />
                          {form.unitOfFuelConsumption}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>
                ))}
            </>
          )}

        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Remark
        </Typography>
        <p>
          {" "}
          {props.selectedEquipment?.remark
            ? props.selectedEquipment?.remark
            : "-"}
        </p>

        {!user?.companyAdmin && (
          <Box>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#0a3f73",
                textTransform: "none",
                marginTop: "10%",
              }}
              onClick={Edit}
            >
              Edit
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );

  return (
    <div>
      <Drawer
        sx={{
          backgroundColor: "transparent",
          "& .MuiDrawer-paper": {
            backgroundColor: "transparent",
            boxShadow: "none",
          },
        }}
        anchor="right"
        open={props.viewFacility}
        onClose={() => props.setViewFacility(false)}
      >
        {list()}
      </Drawer>
    </div>
  );
}

export default ViewEquipment;
